module.exports = __webpack_public_path__ + "static/media/Inter-ExtraBold.568245cc.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-ExtraBold.woff
// module id = 683
// module chunks = 21